/* eslint-disable react-hooks/exhaustive-deps */
import React, { ComponentProps, FC, PropsWithChildren } from 'react';
import { FeatureFlagProvider } from './featureFlagProvider';
import { GtmProvider } from './gtmProvider';

/**
 * A provider created to combine multiple context wrapper components into a single component used to wrap top level app.
 */

const combineComponents = (...components: any[]): FC<PropsWithChildren> => {
  return components.reduce(
    (AccumulatedComponents, CurrentComponent) => {
      return ({ children }: ComponentProps<FC<PropsWithChildren>>): React.ReactElement => {
        return (
          <AccumulatedComponents>
            <CurrentComponent>{children}</CurrentComponent>
          </AccumulatedComponents>
        );
      };
    },
    ({ children }: any) => <>{children}</>,
  );
};

const providers = [FeatureFlagProvider, GtmProvider];

export const AppContextProvider = combineComponents(...providers);
